import { useEffect, useState } from "react";

/**
 * Соответствует CSS `(pointer: coarse)` — сенсор, часть планшетов.
 * Совпадает с логикой увеличения узлов в MapLibreDrawController (Terra Draw select).
 */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const mql = window.matchMedia("(pointer: coarse)");
    const apply = () => setCoarse(mql.matches);
    apply();
    mql.addEventListener("change", apply);
    return () => mql.removeEventListener("change", apply);
  }, []);

  return coarse;
}
